import { XMarkIcon } from "@heroicons/react/20/solid";
import IconButton from "components/elements/IconButton";
import classes from "./classes.module.scss";
import MediaResponseResource from "common/resources/Project/Config/Media/MediaResponseResource";
import { useProjectId } from "hooks/useProjectId";
import { useEffect, useState } from "react";
import { container } from "tsyringe";
import MediaService from "services/projects/MediaService";

type IProps = {
	media: MediaResponseResource;
	isOpen: boolean;
	onClose: () => void;
};

const mediaService = container.resolve(MediaService);

export default function VideoMediaModal(props: IProps) {
	const { iframe } = useIframe(props.media);

	return (
		props.isOpen && (
			<div className={classes["root"]}>
				<div className={classes["backdrop"]} onClick={props.onClose} />
				<div className={classes["content"]}>
					{iframe && <div className={classes["iframe-container"]} dangerouslySetInnerHTML={{ __html: iframe }} />}
					{props.media.url && <IconButton className={classes["close-button"]} icon={<XMarkIcon />} onClick={props.onClose} />}
				</div>
			</div>
		)
	);
}

const useIframe = (media: Pick<MediaResponseResource, "id">) => {
	const { projectId } = useProjectId();
	const [iframe, setIframe] = useState<string | null>(null);

	useEffect(() => {
		mediaService.getIframe(projectId, media.id).then((res) => setIframe(res.iframe));
	}, [media.id, projectId]);

	return { iframe };
};
